module.exports = __webpack_public_path__ + "static/media/leclerc-logo2.c04b82fb.png";